(function (EG) {
  'use strict';

  function omnitureTrackSomethingWentWrong() {
        uitk.analytics.track('error',{errorkey: 'USERS_SOMETHING_WENT_WRONG'});
  }

  var OmnitureUtil = {
    omnitureTrackSomethingWentWrong: omnitureTrackSomethingWentWrong,
  };

  EG.Users.OmnitureUtil = OmnitureUtil;

})(EG);